// extracted by mini-css-extract-plugin
module.exports = {"header":"LinkErrorModal_header__37DoF","text":"LinkErrorModal_text__A-QCc"};